module.exports = __webpack_public_path__ + "/login_ui/img/uz-93b0b48fe4a406bcf18fc15486462a08.svg";